import * as $ from "jquery";
import storage from "../../utils/storage";

export default class ContainerAnnouncementBanner {
  domRoot: JQuery<HTMLElement>;
  params: any;
  closeButton: JQuery<HTMLElement>;
  
  constructor(domRoot: HTMLElement, params: any) {
    this.domRoot = $(domRoot);
    this.params = { ...params };
    // Define close button
    this.closeButton = $(
      ".container--announcement-banner-container_close",
      this.domRoot
    );
    this.init();
  }

  init() {
    this.bindEvents();
    // Check if cookie exists or is expired
    if (!storage.getCookie(this.params.cookieName)) {
      this.domRoot.show();
      this.domRoot.addClass("yes-display");
    }
  }

  bindEvents() {
    var self = this;
    // Set cookie on pressing close button
    this.closeButton.on("click", function () {
      self.domRoot.hide();
      self.domRoot.addClass("no-display");
      // Set cookie
      storage.setCookie(self.params.cookieName, 1, 1, "strict");
    });
  }
}
